// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"CP-z","categoryName":"DP-z","categoryNameSearchHeader":"EP-z","categoryContent":"FP-z","bottomAligned":"GP-z","image":"HP-z","imageNoBackground":"IP-z"};